import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { revertServiceCancellation } from '../../actions/service'
import Button from '../../components/uiKit/Button'
import { showNotification } from '../../actions/notifications'
import analytics from '../../utils/cdpAnalytics'
import { fetchPreviewInvoice } from '../../actions/billing'

function RevertProCancellationContainer(props) {
  const [submitLoading, setSubmitLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  useEffect(() => {
    const { fetchPreviewInvoice } = props
    document.body.style.overflowY = 'hidden' // prevent scrolling while modal is open
    analytics.page('Revert Pro Cancellation Modal')
    fetchPreviewInvoice() // retrieve the latest preview invoice info

    return () => {
      document.body.style.overflowY = '' // overlay is not supported by firefox, so default to blank (auto style comes from css)
      document.body.style.overflowY = 'overlay' // overlay is to prevent windows scrollbars interacting with pagewidth
    }
  }, [])

  async function revertProCancellation() {
    setSubmitLoading(true)
    setErrorMessage(null)

    const {
      revertServiceCancellation,
      fetchPreviewInvoice,
      hideModal,
      showNotification,
    } = props

    try {
      await revertServiceCancellation()
      fetchPreviewInvoice() // retrieve the new preview invoice info
      hideModal()
      showNotification('cancellation reverted', 'Plickers Pro', 'default')
    } catch (error) {
      setSubmitLoading(false)
      setErrorMessage(error.message)
    }
  }

  const {
    billingInfo, previewInvoice, hideModal,
  } = props
  let nextPaymentDateString = ''
  let amountDueDisplayString = ''
  let billingPeriod = ''
  if (previewInvoice) {
    nextPaymentDateString = moment(previewInvoice.date).format('MMMM DD, YYYY')
    amountDueDisplayString = `$${(previewInvoice.amountDue / 100).toFixed(2)}`
    billingPeriod = previewInvoice.plan === process.env.REACT_APP_STRIPE_MONTHLY_PLAN_ID ?
      'month' :
      'year'
  }

  return (
    <div className='revertProCancellationModal'>
      <div className='revertProCancellationModal-header'>
        Keep Plickers Pro
      </div>

      <div className='revertProCancellationModal-sub'>
        <div>Great! We will continue your Plickers Pro subscription.</div>
        <div>
          You will be charged at the end of the current billing period on
          {' '}
          <span>{nextPaymentDateString}</span>
          .
        </div>
      </div>

      <div className='revertProCancellationModal-paymentInfo'>

        {billingInfo && (
          <React.Fragment>
            <div className='revertProCancellationModal-paymentInfo-title'> payment info </div>
            <div className='revertProCancellationModal-paymentInfo-card'>
              {`${billingInfo.card?.brand} •••• •••• •••• ${billingInfo.card?.last4}`}
            </div>
            <div className='revertProCancellationModal-paymentInfo-amount'>
              {amountDueDisplayString}
              /
              {billingPeriod}
            </div>
          </React.Fragment>
        )}

      </div>

      <div className='revertProCancellationModal-actionRow'>
        <Button
          size='xLarge'
          color='blue'
          submitLoading={submitLoading}
          onClickFunction={() => revertProCancellation()}
          label='Yes, Keep it'
        />
        <Button
          size='xLarge'
          color='white'
          label='Cancel'
          onClickFunction={hideModal}
        />
      </div>

      <div className='revertProCancellationModal-errorSpace'>
        {errorMessage && (
        <span>
          {errorMessage}
        </span>
        )}
      </div>
    </div>
  )
}

export default connect(
  (state) => ({
    billingInfo: state.billing,
    previewInvoice: state.previewInvoice,
  }),
  {
    revertServiceCancellation,
    fetchPreviewInvoice,
    showNotification,
  },
)(RevertProCancellationContainer)
